import { QueryKey } from "@tanstack/react-query";

export const ADMIN_CHARGE_KEYS = {
  ADMIN_CHARGES: "adminChargesManagement/adminCharges",
  ADMIN_CHARGE: "adminChargesManagement/adminCharge",
  GET_ADMIN_CHARGES: (params: unknown): QueryKey => [
    ADMIN_CHARGE_KEYS.ADMIN_CHARGES,
    params,
  ],
  GET_ADMIN_CHARGE: (id: string): QueryKey => [
    ADMIN_CHARGE_KEYS.ADMIN_CHARGE,
    id,
  ],
};
